export const MATTRACKERAPIConstants = {
  GET_DASHBOARD: 'getDashboard',
  ADDMATREQUEST: 'addMatRequest',
  GETLOOKUPDATA: 'getLookupData',
  GET_USERS: 'getUsers',
  GET_USER_BY_ID: 'getUserById',
  ADD_USER: 'addUser',
  UPDATE_USER: 'updateUser',
  DELETE_USER: 'deleteUser',
  GET_USER_INFO: 'getUserInfo',
  // Storage Hub endpoints
  GET_STORAGE_HUBS: 'getStorageHubs',
  ADD_STORAGE_HUB: 'addStorageHub',
  UPDATE_STORAGE_HUB: 'updateStorageHub',
  GET_LOOKUP_DATA: 'getLookupData',

  // Attachment API endpoints
  PRESIGN_ATTACHMENT: 'presignAttachment',
  ADD_ATTACHMENT: 'addAttachment',
  GET_ATTACHMENTS_BY_REQUEST: 'getAttachmentsByRequest',
  DOWNLOAD_ATTACHMENT: 'downloadAttachment',
  DELETE_ATTACHMENT: 'deleteAttachment',

  // Status transition endpoint
  UPDATE_REQUEST_STATUS: 'updateRequestStatus',

  // Substation suggestions (autocomplete)
  GET_SUBSTATION_SUGGESTIONS: 'getSubstationSuggestions',

  // Notes endpoints
  ADD_NOTES: 'addNotes',
  GET_NOTES: 'getNotes',

  // â”€â”€ Mat Allocation endpoints â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** POST /matAllocationSave â€” saves allocation without changing status */
  MAT_ALLOCATION_SAVE: 'matAllocationSave',
  /** POST /matAllocationMoveToActive â€” transitions Ready â†’ Active */
  MAT_ALLOCATION_MOVE_TO_ACTIVE: 'matAllocationMoveToActive',
  /** GET /getMatAllocationsByRequestId?requestId=<internalSeq> */
  GET_MAT_ALLOCATIONS_BY_REQUEST: 'getMatAllocationsByRequestId',
  /** GET /getActivePageSourceLocations?requestId=<requestId> â€” Active-page transfer table */
  GET_ACTIVE_PAGE_SOURCE_LOCATIONS: 'getActivePageSourceLocations',
  /** POST /matDelivered â€” marks mats as delivered for an active request */
  MAT_DELIVERED: 'matDelivered',
  /** POST /reviseMatAllocation â€” revises an active mat request */
  REVISE_MAT_ALLOCATION: 'reviseMatAllocation',

  // â”€â”€ Release endpoints â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /getReleasePageData?requestId=<id> â€” inUseQty, existing entries, available locations */
  GET_RELEASE_PAGE_DATA: 'getReleasePageData',
  /** POST /initRelease â€” auto-creates rental return entries (idempotent) */
  INIT_RELEASE: 'initRelease',
  /** POST /transferToLocation â€” manual transfer to hub/rental */
  TRANSFER_TO_LOCATION: 'transferToLocation',
  /** POST /confirmReleaseTransfer â€” completes a staged transfer (In_Transit â†’ target bucket) */
  CONFIRM_RELEASE_TRANSFER: 'confirmReleaseTransfer',
  /** POST /releaseForFutureProject â€” In_Use â†’ Released at same location */
  RELEASE_FOR_FUTURE_PROJECT: 'releaseForFutureProject',
  /** POST /recallFromFutureProject â€” reduces future-project released qty; soft-deletes at 0 */
  RECALL_FROM_FUTURE_PROJECT: 'recallFromFutureProject',
  /** POST /delRelTransfer â€” deletes a release transfer entry */
  DEL_REL_TRANSFER: 'delRelTransfer',

  // â”€â”€ Email endpoint â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** POST /addEmail â€” sends a vendor email */
  ADD_EMAIL: 'addEmail',
  /** GET /getEmailTrail?requestId=<id> â€” returns full email history for a request */
  GET_EMAIL_TRAIL: 'getEmailTrail',

  // â”€â”€ Date Revision endpoints â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** POST /reviseDates â€” creates next date revision for an Active request */
  REVISE_DATES: 'reviseDates',
  /** GET /getDateRevisions?matRequestId=<internalSeq> â€” returns full revision history */
  GET_DATE_REVISIONS: 'getDateRevisions',

  // â”€â”€ Project suggestions (autocomplete) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /getProjectSuggestions?q=<query>&limit=<n> */
  GET_PROJECT_SUGGESTIONS: 'getProjectSuggestions',

  // â”€â”€ POC search endpoint â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /searchPoc?q=<term> â€” search users with role POC by name or email */
  SEARCH_POC: 'searchPoc',

  // â”€â”€ Cancel / Delete request endpoint â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** POST /delMatReq â€” cancels/deletes a Draft or Created mat request */
  DEL_MAT_REQ: 'delMatReq',

  // â”€â”€ Duplicate Request Check endpoint â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /checkDuplicateRequest?substationId=&excludeRequestId= */
  CHECK_DUPLICATE_REQUEST: 'checkDuplicateRequest',

  // â”€â”€ Vendor Profile endpoints â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  /** GET /getVendors?activeOnly=true â€” returns all vendor profiles */
  GET_VENDORS: 'getVendors',
  /** POST /addVendor â€” creates a new vendor profile */
  ADD_VENDOR: 'addVendor',
  /** POST /updateVendor â€” updates an existing vendor profile */
  UPDATE_VENDOR: 'updateVendor',
  /** POST /toggleVendorStatus â€” activates or deactivates a vendor */
  TOGGLE_VENDOR_STATUS: 'toggleVendorStatus',
  /** POST /deleteVendor â€” hard-deletes a vendor record */
  DELETE_VENDOR: 'deleteVendor'
};

/** Emails automatically CC'd on all vendor communications */
export const VENDOR_AUTO_CC_EMAILS: string[] = [];

